import { useContext, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { getParams } from "../../utils/common";
import { isValidSession, logout } from "../../utils/sessionStorage";

import { ErrorBoundary } from "react-error-boundary";
import { UserContext } from "../../context";
import UnexpectedError from "../../screens/Error/UnexpectedError";
import { useGeneralAppStore } from "../../store/generalAppStore";
import ModalVerActa from "../../views/modals/ModalVerActa";
import ModalVerAviso from "../../views/modals/ModalVerAviso";
import ModalVerMotivo from "../../views/modals/ModalVerMotivo";
import ModalRangoFecha from "../../views/modals/ModalRangoFecha";

const UserLayout = () => {
  const { actions } = useContext(UserContext);
  const { modals } = useGeneralAppStore();
  const path = useLocation().pathname

  const token = getParams().token;
  const nav = useNavigate();

  const perfil = actions.getPerfil();

  // resetea el error (si cae en el error boundary) y redirige a la página anterior
  const handleErrorReset = () => {
    nav(-1);
  };

  useEffect(() => {
    if (!isValidSession() && !token) nav("/login");
  }, []);

  useEffect(() => {
    if (actions.hasRole("notificador") && (actions?.user()?.roles?.length == 1) && !path.includes('notificador')) {
      // nav("/notificador/listado-actas");
      nav("/notificador");
    }
  }, [nav]);

  if (!isValidSession()) return null;

  return (
    <>
      <ErrorBoundary FallbackComponent={UnexpectedError} onReset={handleErrorReset}>
        <nav className="navbar d-flex justify-content-around flex-wrap p-2 gap-1">
          <img
            alt="Logo Neuquén Capital"
            height="80%"
            src="https://webservice.muninqn.gov.ar/cglobales/assets/banners/neuquen-2024.svg"
          />

          <div className="d-flex align-items-center gap-sm-2">
            <img alt="imágen perfil" className="imagen-usuario-navbar" src={perfil.imagenUrl} />

            <div className="d-none d-sm-block text-start">
              <small className="nombre-usuario-navbar">{perfil.nombre}</small>
              <br />
              <small className="email-usuario-navbar">{perfil.correoElectronico}</small>
            </div>

            <div className="vr d-none d-sm-block"></div>

            <div className="ms-2 ms-sm-none text-primary" onClick={() => logout()} role="button">
              <i className="fa-solid fa-arrow-right-from-bracket me-2"></i>
              Salir
            </div>
          </div>
        </nav>

        {/* <main className="container-fluid"> */}
        <main>
          <Outlet />
        </main>
      </ErrorBoundary>
      {modals.includes('ver_acta') && <ModalVerActa />}
      {modals.includes('ver_aviso') && <ModalVerAviso />}
      {modals.includes('ver_motivo') && <ModalVerMotivo />}
    
    </>
  );
};

export default UserLayout;
